import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { toastMessage } from "../store/layout";

export default function ToastNavigationListener() {
	const setToastMessageAlert = useSetRecoilState(toastMessage);
	const location = useLocation();

	useEffect(() => {
		const msg = sessionStorage.getItem("redirectToastMessage");
		if (msg) {
			setToastMessageAlert({ message: msg });
			sessionStorage.removeItem("redirectToastMessage");
		}
	}, [location.pathname]);

	return null;
}
